<template>
  <div class="task-wall-withdraw-container">
    <el-card class="search-card">
      <div slot="header" class="flex justify-between">
        <span>许愿墙提现台账查询</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="5">
          <el-select v-model="conditions.state" placeholder="提现状态" clearable style="width: 100%">
            <el-option v-for="(name, value) in stateNameMap" :key="value" :label="name" :value="value" />
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-input v-model="conditions.userName" placeholder="申请人姓名" clearable />
        </el-col>
        <el-col :span="5">
          <el-input v-model="conditions.userTel" placeholder="申请人电话" clearable />
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="table-card">
      <div slot="header" class="flex justify-between">
        <span>提现申请台账</span>
      </div>
      <el-table :data="tableData" border style="width: 100%" v-loading="loading">
        <el-table-column prop="userName" label="申请人" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.userName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="userTel" label="电话" width="120" align="center" />
        <el-table-column prop="amount" label="提现金额(元)" width="110" align="center">
          <template slot-scope="scope">
            <span class="amount-text">￥{{ scope.row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="receiveType" label="收款方式" width="90" align="center">
          <template slot-scope="scope">
            <span>{{ getReceiveTypeName(scope.row.receiveType) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="receiveAccount" label="收款账号" min-width="140" show-overflow-tooltip />
        <el-table-column prop="receiveName" label="收款人" width="100" align="center" />
        <el-table-column prop="state" label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="stateTagType(scope.row.state)" size="small">
              {{ getWithdrawStateName(scope.row.state) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="申请时间" width="160" align="center" />
        <el-table-column label="操作" align="center" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleDetail(scope.row)">详情</el-button>
            <el-button v-if="scope.row.state === WITHDRAW_STATE.WAIT_AUDIT" size="mini" type="primary"
              @click="handleAudit(scope.row)">审核</el-button>
            <el-button v-if="scope.row.state === WITHDRAW_STATE.AUDIT_PASS" size="mini" type="success"
              @click="handlePay(scope.row)">付款</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="pagination.current" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.size"
        :total="pagination.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" style="margin-top: 20px;" />
    </el-card>

    <!-- 审核弹窗 -->
    <el-dialog title="提现审核" :visible.sync="auditDialog.visible" width="480px" append-to-body>
      <el-form label-width="90px">
        <el-form-item label="申请人">
          <span>{{ auditDialog.row.userName }}（{{ auditDialog.row.userTel }}）</span>
        </el-form-item>
        <el-form-item label="提现金额">
          <span class="amount-text">￥{{ auditDialog.row.amount }}</span>
        </el-form-item>
        <el-form-item label="收款信息">
          <span>{{ getReceiveTypeName(auditDialog.row.receiveType) }} {{ auditDialog.row.receiveAccount }}
            （{{ auditDialog.row.receiveName }}）</span>
        </el-form-item>
        <el-form-item label="审核结果">
          <el-radio-group v-model="auditDialog.auditResult">
            <el-radio label="pass">通过</el-radio>
            <el-radio label="reject">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核意见">
          <el-input v-model="auditDialog.auditRemark" type="textarea" :rows="3"
            :placeholder="auditDialog.auditResult === 'reject' ? '拒绝将把冻结金额退回接单人钱包，请填写原因' : '选填'" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="auditDialog.visible = false">取消</el-button>
        <el-button type="primary" :loading="auditDialog.submitting" @click="submitAudit">确认</el-button>
      </div>
    </el-dialog>

    <!-- 付款弹窗 -->
    <el-dialog title="提现付款确认" :visible.sync="payDialog.visible" width="480px" append-to-body>
      <el-form label-width="90px">
        <el-form-item label="申请人">
          <span>{{ payDialog.row.userName }}（{{ payDialog.row.userTel }}）</span>
        </el-form-item>
        <el-form-item label="提现金额">
          <span class="amount-text">￥{{ payDialog.row.amount }}</span>
        </el-form-item>
        <el-form-item label="收款信息">
          <span>{{ getReceiveTypeName(payDialog.row.receiveType) }} {{ payDialog.row.receiveAccount }}
            （{{ payDialog.row.receiveName }}）</span>
        </el-form-item>
        <el-form-item label="付款凭证">
          <el-input v-model="payDialog.payVoucher" placeholder="线下打款流水号/凭证，选填" />
        </el-form-item>
        <el-form-item label="付款备注">
          <el-input v-model="payDialog.payRemark" type="textarea" :rows="3" placeholder="选填" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="payDialog.visible = false">取消</el-button>
        <el-button type="primary" :loading="payDialog.submitting" @click="submitPay">确认已付款</el-button>
      </div>
    </el-dialog>

    <!-- 详情弹窗 -->
    <el-dialog title="提现详情" :visible.sync="detailDialog.visible" width="600px" append-to-body>
      <el-descriptions :column="2" border size="small">
        <el-descriptions-item label="申请人">{{ detailDialog.row.userName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="电话">{{ detailDialog.row.userTel || '-' }}</el-descriptions-item>
        <el-descriptions-item label="提现金额">￥{{ detailDialog.row.amount }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="stateTagType(detailDialog.row.state)" size="small">
            {{ getWithdrawStateName(detailDialog.row.state) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="收款方式">{{ getReceiveTypeName(detailDialog.row.receiveType) }}</el-descriptions-item>
        <el-descriptions-item label="收款人">{{ detailDialog.row.receiveName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="收款账号" :span="2">{{ detailDialog.row.receiveAccount || '-' }}</el-descriptions-item>
        <el-descriptions-item label="申请备注" :span="2">{{ detailDialog.row.applyRemark || '-' }}</el-descriptions-item>
        <el-descriptions-item label="申请时间" :span="2">{{ detailDialog.row.createTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="审核人">{{ detailDialog.row.auditUserName || detailDialog.row.auditUserId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="审核时间">{{ detailDialog.row.auditTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="审核意见" :span="2">{{ detailDialog.row.auditRemark || '-' }}</el-descriptions-item>
        <el-descriptions-item label="付款时间">{{ detailDialog.row.payTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="付款凭证">{{ detailDialog.row.payVoucher || '-' }}</el-descriptions-item>
        <el-descriptions-item label="付款备注" :span="2">{{ detailDialog.row.payRemark || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button @click="detailDialog.visible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listWithdraw,
  auditWithdraw,
  payWithdraw,
  getWithdrawStateName,
  getReceiveTypeName,
  WITHDRAW_STATE,
  WITHDRAW_STATE_NAME
} from '@/api/community/taskWallWithdrawApi'
import { getCommunityId } from '@/api/community/communityApi'
import { getUserName } from '@/api/user/userApi'

export default {
  name: 'TaskWallWithdrawList',
  data() {
    return {
      loading: false,
      tableData: [],
      WITHDRAW_STATE,
      stateNameMap: WITHDRAW_STATE_NAME,
      conditions: {
        state: '',
        userName: '',
        userTel: '',
        communityId: ''
      },
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      auditDialog: {
        visible: false,
        submitting: false,
        row: {},
        auditResult: 'pass',
        auditRemark: ''
      },
      payDialog: {
        visible: false,
        submitting: false,
        row: {},
        payVoucher: '',
        payRemark: ''
      },
      detailDialog: {
        visible: false,
        row: {}
      }
    }
  },
  created() {
    this.conditions.communityId = getCommunityId()
    this.fetchData()
  },
  methods: {
    getWithdrawStateName,
    getReceiveTypeName,
    async fetchData() {
      try {
        this.loading = true
        const params = {
          page: this.pagination.current,
          row: this.pagination.size,
          state: this.conditions.state,
          userName: this.conditions.userName,
          userTel: this.conditions.userTel,
          communityId: this.conditions.communityId
        }
        const res = await listWithdraw(params)
        if (res.code !== 0) {
          this.$message.error(res.msg || '查询失败')
          this.tableData = []
          this.pagination.total = 0
          return
        }
        this.tableData = res.data || []
        this.pagination.total = res.total || 0
      } catch (error) {
        console.error('获取提现台账失败:', error)
        this.$message.error('获取提现台账失败')
      } finally {
        this.loading = false
      }
    },
    stateTagType(state) {
      const map = {
        '1000': 'warning',
        '2000': '',
        '3000': 'success',
        '4000': 'danger'
      }
      return map[state] || 'info'
    },
    handleSearch() {
      this.pagination.current = 1
      this.fetchData()
    },
    handleReset() {
      this.conditions.state = ''
      this.conditions.userName = ''
      this.conditions.userTel = ''
      this.pagination.current = 1
      this.fetchData()
    },
    handleDetail(row) {
      this.detailDialog.row = row
      this.detailDialog.visible = true
    },
    handleAudit(row) {
      this.auditDialog.row = row
      this.auditDialog.auditResult = 'pass'
      this.auditDialog.auditRemark = ''
      this.auditDialog.visible = true
    },
    async submitAudit() {
      if (this.auditDialog.auditResult === 'reject' && !this.auditDialog.auditRemark) {
        this.$message.warning('拒绝时请填写审核意见')
        return
      }
      try {
        this.auditDialog.submitting = true
        const res = await auditWithdraw({
          withdrawId: this.auditDialog.row.withdrawId,
          auditResult: this.auditDialog.auditResult,
          auditRemark: this.auditDialog.auditRemark,
          auditUserName: getUserName()
        })
        if (res.code === 0) {
          this.$message.success(res.msg || '审核成功')
          this.auditDialog.visible = false
          this.fetchData()
        } else {
          this.$message.error(res.msg || '审核失败')
        }
      } catch (error) {
        console.error('提现审核失败:', error)
        this.$message.error('提现审核失败')
      } finally {
        this.auditDialog.submitting = false
      }
    },
    handlePay(row) {
      this.payDialog.row = row
      this.payDialog.payVoucher = ''
      this.payDialog.payRemark = ''
      this.payDialog.visible = true
    },
    async submitPay() {
      try {
        this.payDialog.submitting = true
        const res = await payWithdraw({
          withdrawId: this.payDialog.row.withdrawId,
          payVoucher: this.payDialog.payVoucher,
          payRemark: this.payDialog.payRemark
        })
        if (res.code === 0) {
          this.$message.success(res.msg || '付款确认成功')
          this.payDialog.visible = false
          this.fetchData()
        } else {
          this.$message.error(res.msg || '付款确认失败')
        }
      } catch (error) {
        console.error('提现付款确认失败:', error)
        this.$message.error('提现付款确认失败')
      } finally {
        this.payDialog.submitting = false
      }
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.fetchData()
    }
  }
}
</script>

<style lang="scss" scoped>
.task-wall-withdraw-container {
  padding: 20px;

  .search-card {
    margin-bottom: 20px;
  }

  .amount-text {
    color: #f56c6c;
    font-weight: bold;
  }

  .flex {
    display: flex;
  }

  .justify-between {
    justify-content: space-between;
    align-items: center;
  }
}
</style>
